import { render, staticRenderFns } from "./StarboxxLoadingOverlayComponent.vue?vue&type=template&id=57d25252&scoped=true&"
import script from "./StarboxxLoadingOverlayComponent.vue?vue&type=script&lang=js&"
export * from "./StarboxxLoadingOverlayComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d25252",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VOverlay})
